var URL = 'https://ssl-player2.720static.com/krp/krp_player_1.20.11.js'; // var URL = '../../dist/krp_player_1.20.9.js';

export default (function (cursomURL) {
  return new Promise(function (resolve) {
    var doc = document;
    var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
    var node = doc.createElement('script');

    node.onload = function () {
      resolve();
    };

    node.onerror = function () {};

    if (cursomURL != undefined) {
      URL = cursomURL;
    }

    node.src = URL;
    head.appendChild(node);
  });
});